export const routes = [
  {
    path: 'conquistas/gestao',
    name: 'talkvia_gamification_admin',
    meta: { permissions: ['administrator'] },
    component: () => import('./Index.vue'),
  },
  {
    path: 'conquistas',
    name: 'talkvia_gamification',
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    component: () => import('./Index.vue'),
  },
];
